import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Typography } from 'antd';

import { PitstopSelect, PistopTags } from 'shared';

const DEFAULT_DISPLAY_FIELD = 'vin';
const DISPLAY_FIELDS = ['make', 'model', 'name', 'vin'];
const { Text } = Typography;

const Header = ({ cars, displayField, displayFieldChange, fontSize }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Text style={{ fontSize }}>
        Selected Vehicles: {!cars.length && 'None'}
      </Text>
      {cars.length !== 0 && (
        <PitstopSelect
          options={DISPLAY_FIELDS}
          onChange={displayFieldChange}
          value={displayField}
        />
      )}
    </div>
  );
};

Header.propTypes = {
  cars: PropTypes.array,
  displayField: PropTypes.string,
  displayFieldChange: PropTypes.func,
  fontSize: PropTypes.string,
};

const SelectedCars = ({ cars, onUnselect, fontSize }) => {
  const [displayField, setDisplayField] = useState(DEFAULT_DISPLAY_FIELD);

  const handleDisplayFieldChange = (newDisplayField) => {
    setDisplayField(newDisplayField);
  };

  return (
    <>
      <Header
        fontSize={fontSize}
        cars={cars}
        displayField={displayField}
        displayFieldChange={handleDisplayFieldChange}
      />
      <PistopTags
        closable={true}
        displayField={displayField}
        entities={cars}
        onClose={onUnselect}
        uniqueKey="id"
      />
    </>
  );
};

SelectedCars.propTypes = {
  cars: PropTypes.array.isRequired,
  onUnselect: PropTypes.func.isRequired,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SelectedCars.defaultProps = {
  cars: [],
  fontSize: '14px',
};

export default observer(SelectedCars);
